export const isMobileSafari = () => {
  const userAgent = navigator.userAgent
  if (userAgent.match(/(iPod|iPhone|iPad)/) !== null
  && userAgent.match(/AppleWebKit/) !== null
  && userAgent.search('CriOS') < 0
  && userAgent.match(/Safari/) !== null) {
    return true
  }
  return false
}

export const isMobile = () => {
  const userAgent = navigator.userAgent
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(userAgent)
  ) {
    return true
  }
  return false
}

export const isAndroid = () => {
  const userAgent = navigator.userAgent
  if (
    /Android/i.test(userAgent)
  ) {
    return true
  }
  return false
}

export const isIOS = () => {
  const userAgent = navigator.userAgent
  if (
    /iPhone|iPad|iPod/i.test(userAgent)
  ) {
    return true
  }
  return false
}

export const isNaverApp = () => {
  const userAgent = navigator.userAgent
  if (
    /NAVER/i.test(userAgent)
  ) {
    return true
  }
  return false
}

export const isFacebook = () => {
  const userAgent = navigator.userAgent || ''
  return userAgent.includes('FBAN') || userAgent.includes('FBAV')
}

export const isInstagram = () => {
  const userAgent = navigator.userAgent || ''
  return userAgent.toLowerCase().includes('instagram');
}

export const isAboveWindows10 = () => {
  const userAgent = navigator.userAgent;
  const regex = /Windows NT (\d+\.\d+)/;
  const match = userAgent.match(regex);

  if (match) {
    const version = parseFloat(match[1]);
    return version >= 10;
  }

  return false;
}

const enum OS {
  WINDOWS = 'Windows',
  MAC = 'Mac',
  Ubuntu = 'Ubuntu',
  Fedora = 'Fedora',
  UNKNOWN = 'Unknown',
}

const enum Browser {
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  Safari = 'Safari',
  Edge = 'Edge',
  InternetExplorer = 'Internet Explorer',
  Opera = 'Opera',
  UNKNOWN = 'Unknown',
}

export const getBrowserAndOSInfo = () => {
  const userAgent = navigator.userAgent;

  const unknownVersion = '-1'
  
  let browser: Browser = Browser.UNKNOWN;
  let browserVersion = unknownVersion;
  let os: OS = OS.UNKNOWN;
  let osVersion = unknownVersion;

  // 브라우저 정보
  if (userAgent.includes('Chrome')) {
    browser = Browser.Chrome
    browserVersion = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/)?.[1] || unknownVersion;
  } else if (userAgent.includes('Firefox')) {
    browser = Browser.Firefox
    browserVersion = userAgent.match(/Firefox\/(\d+\.\d+)/)?.[1] || unknownVersion;
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browser = Browser.Safari
    browserVersion = userAgent.match(/Version\/(\d+\.\d+)/)?.[1] || unknownVersion;
  } else if (userAgent.includes('Edge')) {
    browser = Browser.Edge
    browserVersion = userAgent.match(/Edg\/(\d+\.\d+)/)?.[1] || unknownVersion;
  } else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
    browser = Browser.InternetExplorer
    browserVersion = userAgent.match(/MSIE (\d+\.\d+)/)?.[1] || userAgent.match(/rv:(\d+\.\d+)/)?.[1] || unknownVersion;
  } else  if (userAgent.includes('OPR') || userAgent.includes('Opera')) {
    browser = Browser.Opera
    browserVersion = userAgent.match(/OPR\/(\d+\.\d+)/)?.[1] || userAgent.match(/Opera\/(\d+\.\d+)/)?.[1] || unknownVersion;
  }

  // OS & OS 버전 추출
  if (userAgent.includes('Windows NT')) {
    os = OS.WINDOWS;
    //   '10.0': '10 or 11',
    //   '6.3': '8.1',
    //   '6.2': '8',
    //   '6.1': '7',
    //   '6.0': 'Vista',
    //   '5.1': 'XP',
    osVersion = userAgent.match(/Windows NT (\d+\.\d+)/)?.[1] || unknownVersion;
  } else if (userAgent.includes('Mac OS X')) {
    os = OS.MAC;
    osVersion = userAgent.match(/Mac OS X (\d+[_.\d]+)/)?.[1]?.replace(/_/g, '.') || unknownVersion;
  } else if (userAgent.includes('Linux')) {
    if (userAgent.includes('Ubuntu')) {
      osVersion = userAgent.match(/Ubuntu\/(\d+\.\d+)/)?.[1] || unknownVersion;
      os = OS.Ubuntu;
    } else if (userAgent.includes('Fedora')) {
      osVersion = userAgent.match(/Fedora\/(\d+)/)?.[1] || unknownVersion;
      os = OS.Fedora;
    } 
  }

  return { browser, browserVersion, os, osVersion }
}

export const isAvailableMagicLine = () => {
  const { browser, browserVersion, os, osVersion } = getBrowserAndOSInfo()
  let isAvailable = false
  if (os === OS.WINDOWS && parseFloat(osVersion) >= 5.1) {
    isAvailable = true
  } else if (os === OS.MAC && parseFloat(osVersion) >= 10.10) {
    isAvailable = true
  } else if (os === OS.Ubuntu && parseFloat(osVersion) >= 14.04) {
    isAvailable = true
  } else if (os === OS.Fedora && parseFloat(osVersion) >= 23) {
    isAvailable = true
  } else {
    isAvailable = false
    return isAvailable
  }

  if (browser === Browser.Chrome && parseFloat(browserVersion) >= 45) {
    isAvailable = true
  } else if (browser === Browser.Firefox && parseFloat(browserVersion) >= 39) {
    isAvailable = true
  } else if (browser === Browser.Safari && parseFloat(browserVersion) >= 6) {
    isAvailable = true
  } else if (browser === Browser.Edge) {
    isAvailable = true
  } else if (browser === Browser.Opera && parseFloat(browserVersion) >= 21) {
    isAvailable = true
  } else if (browser === Browser.InternetExplorer && parseFloat(browserVersion) >= 9) {
    isAvailable = true
  } else {
    isAvailable = false
    return isAvailable
  }
  return isAvailable
}
